<template>
  <div class="container">

    <div class="min-size"></div>

    <div class="content flex-column">
      <div class="item" @click="changeTo('accueil')"><div class="text">Accueil</div></div>
      <div class="item" @click="toggleDomaine" :class="[{active: this.domaineActive}]"><div class="text">Domaines d'activité</div>
        <img src="../../img/navbar/petite_fleche_navbar_mobile.svg" alt="">
      </div>
      <transition name="size">
        <div class="sub-menu" v-if="this.domaineActive">
          <div class="item" @click="changeTo('domaine')"><div class="text">Télécommunications</div></div>
          <div class="item" @click="changeTo('domaine-transport')"><div class="text">Transports</div></div>
          <div class="item" @click="changeTo('domaine-cfcf')"vv><div class="text">Courant fort / Courant faible</div></div>
          <div class="item" @click="changeTo('domaine-securite')"><div class="text">Sécurité incendie</div></div>
        </div>
      </transition>
      <div class="item" @click="toggleSociete" :class="[{active: this.societeActive}]"><div class="text">La société</div>
        <img src="../../img/navbar/petite_fleche_navbar_mobile.svg" alt="">
      </div>
      <transition name="size">
        <div class="sub-menu" v-if="this.societeActive">
          <div class="item" @click="changeTo('societe')"><div class="text">Description</div></div>
          <div class="item" @click="changeTo('societe-ambition')"><div class="text">Ambition</div></div>
          <div class="item" @click="changeTo('societe-philosophie')"><div class="text">Philosophie et Valeurs</div></div>
        </div>
      </transition>
      <div class="item" @click="toggleService" :class="[{active: this.serviceActive}]"><div class="text">Services</div>
        <img src="../../img/navbar/petite_fleche_navbar_mobile.svg" alt="">
      </div>
      <transition name="size">
        <div class="sub-menu" v-if="this.serviceActive">
          <div class="item" @click="changeTo('assistance')"><div class="text">Assistance technique</div></div>
          <div class="item" @click="changeTo('centre-service')"><div class="text">Centre de service</div></div>
        </div>
      </transition>
      <div class="item" @click="changeTo('accueil', 'confiance')"><div class="text">Il nous font confiance</div></div>
      <div class="item" @click="changeTo('contact')"><div class="text">Contact</div></div>
    </div>

    <div class="space"></div>

  </div>
</template>

<script>
    import {menuBus} from "../../main";

    export default {
    data() {
        return {
            serviceActive: false,
            societeActive: false,
            domaineActive: false,
        }
    },
      methods: {
        toggleService() {
            this.serviceActive = !this.serviceActive;
        },
          toggleSociete() {
              this.societeActive = !this.societeActive;
          },
          toggleDomaine() {
              this.domaineActive = !this.domaineActive;
          },
          changeTo(pageName, id) {
              document.getElementsByTagName('body')[0].classList.remove('blocked');
              menuBus.$emit('changePage', pageName, id);
          }
      }
  }
</script>

<style scoped>
  .container {
    width: 100%;
    max-height: 100vh;
    height: 500px;
    min-height: fit-content;
    background-color: white;

    position: fixed;
    z-index: 70;
  }
  .min-size {
    width: 100%;
    height: 150px;
  }
  .content {
    width: 100%;
    height: calc(100% - 150px);
    justify-content: flex-start;

    overflow-y: scroll;
    scrollbar-width: none;
  }
  .content::-webkit-scrollbar {
    width: 0;
  }

  .item {
    width: calc(100% - 60px);
    height: 50px;
    min-height: 50px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    margin: 0 30px;

    cursor: pointer;

    display: flex;
    justify-content: flex-start;
    align-items: center;

    position: relative;
  }

  .item img {
    height: 40%;
    transform: rotate(180deg);
    transition: all 0.2s;

    position: absolute;
    right: 10px;
  }
  .item.active img {
    transform: rotate(270deg);
  }

  .sub-menu {
    width: calc(100% - 60px);
  }

  .space {
    height: 20px;
  }

  .size-enter-active,
  .size-leave-active {
    transition: all 0.5s;
    max-height: 230px;
  }
  .size-enter,
  .size-leave-to
  {
    opacity: 0;
    max-height: 0px;
  }


  /* Mobile */
  @media (min-width: 1101px) {
    .container {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/accueil/HamburgerMenu.vue